<div class="container">
  <button
    type="button"
    mat-icon-button
    class="close-button"
    (click)="this.close()"
  >
    <mat-icon>close</mat-icon>
  </button>
  <div class="header">
    <h1 class="title">
      {{
        this.data.csvType === 'KeyActionEvaluations'
          ? 'キーアクション評価'
          : 'サマリー'
      }}のダウンロード
    </h1>
  </div>
  <div class="file-information-details">
    <div class="detail">
      <label class="label" for="start-date">開始日：</label>
      <div class="input-with-error">
        <div class="value">
          <app-date-input
            class="date-input"
            [id]="'start-date'"
            [inputDate]="this.startDate"
          ></app-date-input>
        </div>
        @if (this.formGroup.hasError('dateRangeInvalid')) {
          <div class="input-error">
            開始日は終了日より前の日付を選択してください。
          </div>
        }
      </div>
    </div>
    <div class="detail">
      <label class="label" for="end-date">終了日：</label>
      <div class="value">
        <app-date-input
          class="date-input"
          [id]="'end-date'"
          [inputDate]="this.endDate"
        ></app-date-input>
      </div>
    </div>
  </div>
  <div class="action-buttons">
    <button class="cancel" rectangle variant="secondary" (click)="this.close()">
      キャンセル
    </button>
    <button
      class="export-assessment"
      rectangle
      [disabled]="this.formGroup.invalid"
      (click)="submit()"
    >
      エクスポート
    </button>
  </div>
</div>
